import { createAsyncThunk } from "@reduxjs/toolkit";
import { NOTIFY } from "constants/notifyType";
import Notify from "helpers/Notify";
import { socialMediaLinksApi } from "service/socialMediaLinksApi";

export const getAllSocialMediaLinks = createAsyncThunk(
  "getAllSocialMediaLinks",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await socialMediaLinksApi.getAll();
      return data.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  },
);

export const createSocialMediaLink = createAsyncThunk(
  "createSocialMediaLink",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await socialMediaLinksApi.create(body);
      Notify(NOTIFY.type.success, NOTIFY.message.add);
      dispatch(getAllSocialMediaLinks());
      return data.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  },
);

export const updateSocialMediaLink = createAsyncThunk(
  "updateSocialMediaLink",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const { data } = await socialMediaLinksApi.update(id, formData);
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      return data.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  },
);

export const deleteSocialMediaLink = createAsyncThunk(
  "deleteSocialMediaLink",
  async (id, { rejectWithValue }) => {
    try {
      await socialMediaLinksApi.remove(id);
      Notify(NOTIFY.type.success, NOTIFY.message.delete);
      return id;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  },
);
